// @flow

import React from "react";
import { Route, Redirect } from "react-router-dom";
import * as Paths from "./constants";

type Props = {
  component: typeof React.Component | Function,
  isAuthenticated: boolean,
  location?: Location,
  path: string,
};

const PrivateRoute = ({ component, isAuthenticated, location, path }: Props) => {
  if (!isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: `${Paths.LOGIN_PATH}`,
          state: { redirect: location && location.pathname },
        }}
      />
    );
  }

  return <Route path={path} component={component} />;
};

export default PrivateRoute;
